import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './WeekPicks.css';
import PickModal from './PickModal';

const WeekPicks = () => {
  const currentWeek = '17'; // Hardcoded current week
  const [weekNum, setWeekNum] = useState(currentWeek.toString());
  const [picks, setPicks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loggedInUserId, setLoggedInUserId] = useState(null);

  const [showPickModal, setShowPickModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  useEffect(() => {
    handleFetchWeekPicks();
  }, [weekNum]);

  // Add this useEffect to decode JWT and get userId
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // Decode JWT to get userId (payload is the middle part)
        const payload = JSON.parse(atob(token.split('.')[1]));
        setLoggedInUserId(payload.userId);
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  }, []);

  // Simplified handler - just update state
  const handleWeekChange = (e) => {
    setWeekNum(e.target.value); // useEffect will automatically fetch
  };

  // Just shows the submit pick screen and sets the user, biz logic is in PickModal.jsx
  const handleSubmitPick = (userId) => {
    setSelectedUser(userId);
    setShowPickModal(true);
  };

  const handleResultChange = async (userId, result) => {
    const token = localStorage.getItem('token');
    try {
      try {
        await fetch('https://ux97q9k5kb.execute-api.us-east-2.amazonaws.com/prod/picks/result', {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({userId, weekNum, result})
       });
      } catch (error) {
        console.error("Error updating result: ", error)
      }
  
      console.log("Handling Bet Result Change")
  
      // Refresh the picks to show updated result
      handleFetchWeekPicks();
    } catch (error) {
      console.error('Error updating result:', error);
    }
  };

  const handleFetchWeekPicks = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`https://ux97q9k5kb.execute-api.us-east-2.amazonaws.com/prod/picks/week/${weekNum}`);
      if (!response.ok) {
        throw new Error('Failed to fetch picks')
      }
      const data = await response.json();
      const picks = typeof data === 'string' ? JSON.parse(data) : data;
      setPicks(picks)
      
    } catch (error) {
      console.error('Error fetching week picks:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    
    // Toggle direction if clicking same column
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    
    setSortConfig({ key, direction });
    
    // Sort picks
    const sortedPicks = [...picks].sort((a, b) => {
      if (key === 'record') {
        // Sort by wins (descending by default for records)
        const diff = b.wins - a.wins;
        return direction === 'asc' ? -diff : diff;
      }

      if (key === 'odds') {
        // Parse odds as numbers (removes + or -)
        const aOdds = parseInt(a.odds);
        const bOdds = parseInt(b.odds);
        return direction === 'asc' ? aOdds - bOdds : bOdds - aOdds;
      }

      if (key === 'result') {
        // Only care about Win or Loss; treat all else as last
        const order = { 'Win': 1, 'Loss': 2 };
        const aOrder = order[a.result] || 999;
        const bOrder = order[b.result] || 999;
        return direction === 'asc' ? aOrder - bOrder : bOrder - aOrder;
      }
      
      // For other columns
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    
    setPicks(sortedPicks);
  };

  // Hard-coded map: weekNum (string) -> name
  // Who's funding that week's bet
  const biggestLoser = {
    '02': 'Gabe',
    '03': 'Will',
    '04': 'Zach',
    '05': 'Will',
    '06': 'Noah',
    '07': 'Dan',
    '08': 'Will',
    '09': 'Noah',
    '10': 'Tohy',
    '11': 'Nat',
    '12': 'Tohy',
    '13': 'Stallion',
    '14': 'Tohy',
    '15': 'Stallion',
    '16': 'Gavé',
    '17': 'Will',
    '31': 'Stallion',
    '71': 'Dan, Will, Noah'
  };

  

  return (
    <div className="week-picks">
      <h1> OIM FANTASY PARLAY 2025</h1>
      <h2>
        {weekNum === '31' ? (
          <>
            Thanksgiving Special
            {biggestLoser[weekNum] && (
              <> (Biggest Loser: {biggestLoser[weekNum]})</>
            )}
          </>
        ) : weekNum === '71' ? (
          <>
            Christmas Special
            {biggestLoser[weekNum] && (
              <> (Biggest Loser: {biggestLoser[weekNum]})</>
            )}
          </>
        ) : (
          <>
            Week {weekNum} Picks
            {biggestLoser[weekNum] && (
              <> (Biggest Loser: {biggestLoser[weekNum]})</>
            )}
          </>
        )}
      </h2>

      {/* Week Selector */}
      <div style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem" }}>
        <select
          id="week-selector"
          value={weekNum}
          onChange={handleWeekChange}
        >
          {(() => {
            // Build week numbers as strings (start at 02, end at 13 for currentWeek===13)
            const weekOptions = [];
            for (let i = 2; i <= 12; i++) {
              const week = i.toString().padStart(2, '0');
              weekOptions.push({ value: week, label: `Week ${week}` });
            }
            // Insert 'Thanksgiving' special after week 12 (value 31)
            weekOptions.push({ value: '31', label: 'Thanksgiving' });
            // Week 13 as normal after Thanksgiving
            // Make dynamic to allow selecting ALL weeks up to currentWeek (including >13, e.g., 14, 15, etc).
            // Add all weeks [13..currentWeek] (as numbers) after Week 12/Thanksgiving, if currentWeek > 13
            let curr = parseInt(currentWeek, 10);
            if (curr >= 13) {
              for (let w = 13; w <= 16; w++) {
                weekOptions.push({ value: w.toString(), label: `Week ${w}` });
              }
            }
            weekOptions.push({ value: '71', label: 'Christmas' });
            if (curr >= 17) {
              for (let w = 17; w <= 17; w++) {
                weekOptions.push({ value: w.toString(), label: `Week ${w}` });
              }
            }
            return weekOptions.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ));
          })()}
        </select>
        {weekNum === '31' && (
          <img
            src="/turkey.png"
            alt="Turkey"
            style={{ height: 32, width: 'auto', verticalAlign: 'middle', marginLeft: '0.75rem' }}
          />
        )}
        {weekNum === '71' && (
          <img
            src="/santa.png"
            alt="Santa"
            style={{ height: 60, width: 'auto', verticalAlign: 'middle', marginLeft: '0.25rem' }}
          />
        )}
      </div>
      
      {/* The Picks Header */}
      <div className="picks-table">
        {isLoading ? (
          <div className="loading-state" role="status" aria-live="polite">
            <div className="loading-spinner" />
            <span>Loading picks…</span>
          </div>
        ) : (
          <table>
          <thead>
            <tr>
              <th>OIM</th>
              <th>Pick</th>
              <th onClick={() => handleSort('odds')} style={{ cursor: 'pointer' }}>
                Odds {sortConfig.key === 'odds' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                </th>
                <th onClick={() => handleSort('result')} style={{ cursor: 'pointer' }}>
                  Result {sortConfig.key === 'result' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                </th>
              <th onClick={() => handleSort('record')} style={{ cursor: 'pointer' }}>
                Record {sortConfig.key === 'record' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
            </tr>
          </thead>
            {/* The actual picks per OIM */}
            <tbody>
              {picks.map((pick, index) => (
                <tr key={index}>
                  <td className="userId">
                    <Link 
                      to={`/user/${pick.userId}`} 
                      style={{ color: "#2e47ad", textDecoration: "underline" }}
                    >
                      {pick.userId}
                    </Link>
                  </td>
                  {/* Pick Buttons */}
                  <td className="pick">
                    {(pick.result === 'Pending' || pick.result == null) ? (
                      pick.pick ? (
                        <>
                          {pick.pick} 
                          {loggedInUserId === pick.userId && (
                            <button className="edit-pick-button" onClick={() => handleSubmitPick(pick.userId)}>Edit</button>
                          )}
                        </>
                      ) : (
                        loggedInUserId === pick.userId && (
                          <button className="pick-button" onClick={() => handleSubmitPick(pick.userId)}>Make Pick</button>
                        )
                      )
                    ) : (
                      pick.pick ? pick.pick : null
                    )}
                  </td>
                  <td className="odds">{pick.odds}</td>
                  <td className="result">
                    {(weekNum === currentWeek && loggedInUserId === "Alex") ? (
                      <select 
                        value={pick.result ?? "Pending"}
                        onChange={(e) => handleResultChange(pick.userId, e.target.value)}
                        className="result-dropdown"
                      >
                        <option value="Pending">Pending</option>
                        <option value="Win">Win</option>
                        <option value="Loss">Loss</option>
                      </select>
                    ) : (
                      pick.result ?? "Pending"
                    )}
                  </td>
                  <td className="record">{pick.wins}-{pick.losses}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
  
      {/* Add PickModal here - right before closing div */}
      <PickModal
        isOpen={showPickModal}
        onClose={() => setShowPickModal(false)}
        userId={selectedUser}
        weekNum={weekNum}
        onSuccess={handleFetchWeekPicks}
      />
    </div>
  );
};

export default WeekPicks;